import React from "react";
import loaderGif from "../../assets/gif/loader.gif";

const Loader = ({ height = "300px", size = 80 }) => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ height }}
  >
    <img src={loaderGif} alt="Loading..." style={{ width: size, height: size }} />
  </div>
);

export default Loader;
